<template>
  <div>
    <input v-if="isInput" :type="`${type}`" class="form-control wfh-input-border wfh-input-padding wfh-input-text"
           v-bind:value="value"
           @input="$emit('input', $event.target.value)">

    <div v-if="isDate">
      <div class="position-relative d-flex wfh-input-override">
        <v-ctk-datepicker
            format="YYYY-MM-DD"
            formatted="YYYY-MM-DD"
            v-model="dateValue"
            :no-button-now="true"
            :auto-close="true"
            :no-label="true"
            :only-date="true"
        />
        <img
            v-bind:src="'/images/date.svg'"
            class="position-absolute align-self-center"
            style="right: 8px;"
        />
      </div>
    </div>

    <div class="wfh-v-select-override" v-if="isOptions">
      <v-select
          :options="options"
          :filterable="false"
          :clearable="false"
          v-bind:value="value"
          @input="handleSelectInput"
          :reduce="(item) => item.value"
      >
      </v-select>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: { vSelect },

  props: {
    type: {
      required: true,
      type: String,
    },
    value: {
      required: true,
    },
    options: {
      required: false,
    },
  },

  data () {
    return {
      dateValue: this.value,
    };
  },

  watch: {
    dateValue () {
      this.$emit('input', this.dateValue);
    },
  },

  computed: {
    isInput () {
      return ['text', 'number'].includes(this.type);
    },

    isDate () {
      return this.type === 'date';
    },

    isOptions () {
      return this.type === 'dropdown';
    },
  },

  methods: {
    handleSelectInput (value) {
      this.$emit('input', value);
    },
  },
};
</script>
